import ToolBar from '@/components/ToolBar';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { ClientResponse } from '@brainvaulttech/dgr-react-sdk';
import { ClientCreate } from '@pages/clients/ClientCreate';
import { ClientUpdate } from '@pages/clients/ClientUpdate';
import { X } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

const CreateUpdateClientModal = ({
  onClose,
  onUpdate,
  operation,
  clientId,
}: {
  onClose: () => void;
  onUpdate: (updatedClient: ClientResponse) => void;
  operation: 'CREATE_CLIENT' | 'UPDATE_CONTACT';
  clientId?: string;
}) => {
  const { setValue } = useFormContext();
  return (
    <Sheet modal={true} open={true}>
      <SheetContent
        hideCloseButton={true}
        className="w-[75vw] h-[90vh] p-8 flex flex-col scrollbar-hide focus:outline-none rounded-lg gap-0"
        tabIndex={-1}
        side={'center'}
      >
        <div className="flex flex-row justify-between">
          <ToolBar title={operation === 'CREATE_CLIENT' ? 'Add New Client' : 'Add New Contact'} />
          <div className="h-fit border-[1px] rounded-sm p-1">
            <X color="#676767" className="h-[20px] w-[20px] cursor-pointer " onClick={onClose} />
          </div>
        </div>
        {operation === 'CREATE_CLIENT' && (
          <ClientCreate
            displayType="MODAL"
            onSave={(client) => {
              setValue('contactId', null);
              setValue('case.attorneyId', null);
              onUpdate(client);
              onClose();
            }}
            onCancel={onClose}
          />
        )}
        {operation === 'UPDATE_CONTACT' && (
          <ClientUpdate
            displayType="MODAL"
            defaultActiveStep={1}
            selectedClientId={clientId}
            onSave={(client) => {
              onUpdate(client);
              onClose();
            }}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CreateUpdateClientModal;
